import { render, staticRenderFns } from "./welcomeModal.vue?vue&type=template&id=6e733c10&scoped=true"
import script from "./welcomeModal.vue?vue&type=script&lang=js"
export * from "./welcomeModal.vue?vue&type=script&lang=js"
import style0 from "./welcomeModal.vue?vue&type=style&index=0&id=6e733c10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e733c10",
  null
  
)

export default component.exports